"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const videofilled = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-videofilled` : '') + (description ? ` desc-videofilled` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-videofilled"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-videofilled"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M2.34 3.26v17.49a1.5 1.5 0 0 0 2.2 1.32l16.33-8.75a1.5 1.5 0 0 0 0-2.64L4.55 1.93a1.5 1.5 0 0 0-2.21 1.33Z",
    fill: "#100D0D",
    stroke: "black",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};
var _default = exports.default = videofilled;